<script setup>
import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
import localSave from '@utils/local-save'
import { useStore } from '@composables/use-store'

const store = useStore()
const route = useRoute()
const router = useRouter()

const searchInput = ref(null)
const searchKeyword = ref('')

const routeKeyword = computed(() => route && route.params && route.params.keyword)

onMounted(() => {
    if (routeKeyword.value) {
        searchKeyword.value = routeKeyword.value.replace(/_/g, ' ')
        store.commit('search/UPDATE_KEYWORD', searchKeyword.value)
    }
    searchInput.value.focus()
})

function onSearch(keyword) {
    store.commit('search/UPDATE_KEYWORD', (keyword || '').replace(/_/g, ' '))
}

function onClose() {
    if (searchKeyword.value && searchKeyword.value.length) {
        searchKeyword.value = ''
        return
    }

    const previousPath = localSave.get('searchPreviousPath', 'sessionStorage')

    if (previousPath && !previousPath.includes('/search')) {
        router.push({ path: previousPath, query: { back: true } })
    }
}
</script>

<template>
    <div class="search-bar">
        <BaseSearchInput
            ref="searchInput"
            v-model="searchKeyword"
            placeholder="What do you want to listen to?"
            variant="page"
            autofocus
            @search="onSearch"
        >
            <template #append>
                <a @click="onClose">
                    <BaseIcon
                        class="search-bar-close-icon"
                        name="x"
                    />
                </a>
            </template>
        </BaseSearchInput>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.search-bar {
    display: flex;
    align-items: center;
    width: 100%;
    height: $size-search-bar-height;
    padding: 0 $s-xl;
    background-color: $c-searchbar-bg;
}

.search-bar-close-icon {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    cursor: pointer;
    fill: $c-white;
}
</style>
